module.exports = __webpack_public_path__ + "static/elemental_gem_earth-d8e3d2f968e12a82475643ce96dfc151.jpg";